module.exports = __webpack_public_path__ + "img/eden_logo_icon.661090d6.svg";